// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect } from 'react'
import * as pages from '../pages'
import { RoutedApp } from '../lib'
import logo from '../logo.svg'
import { Route } from 'react-router'


const BackofficeApp: React.FC = () => {
  const gettext: (value: string) => string = (value) => value

  useEffect(() => {
    document.title = "Backoffice - Molano Cloud"
  }, [])

  return (
    <RoutedApp logo={logo} name={gettext("Molano Backoffice")} ready={true}>
      <Route exact path="/procurement/orders/create" component={() => (<pages.CreatePurchaseOrder/>)}/>
      <Route exact path="/procurement/orders" component={() => (<pages.PurchaseOrderList/>)}/>
      <Route exact path="/procurement/suppliers" component={pages.SupplierList}/>
    </RoutedApp>
)}

export default BackofficeApp
